import { useState } from 'react'
import {
  RentChargesFilters,
  RentChargesListTable,
} from '../organism'
import {
  RentChargesReportFilterInput,
  OrderDirectionOption,
  PageSizeOption,
  useGetRentChargesReportQuery,
} from '@/graphql/generated'
import { Pagination } from '../molecules'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/reportTexts.json'

const initialFilters: RentChargesReportFilterInput = {
  createdAtFrom: null,
  createdAtTo: null,
  typeOption: null,
  statusOption: null,
  orderDirection: OrderDirectionOption.Desc,
  pageSize: PageSizeOption.TwentyFive,
  page: null,
  search: null,
  countryId: null,
  stateId: null,
  cityId: null,
}

export const RentChargesReportPage = () => {
  const userLanguage = useUserLanguage()
  const texts =
    (userLanguage === 'es'
      ? textsData.es
      : textsData.en).rentChargeReport

  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] =
    useState<RentChargesReportFilterInput>(initialFilters)

  const handleFilterChange = (
    newFilters: RentChargesReportFilterInput
  ) => {
    setFilters(newFilters)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setFilters({ ...filters, page: page.toString() })
  }

  const { data } = useGetRentChargesReportQuery({
    variables: {
      filterInput: {
        ...filters,
        page: currentPage.toString(),
      },
    },
    fetchPolicy: 'network-only',
  })

  const currentDataCount =
    data?.rentChargesReport?.items?.length || 0
  const totalPages =
    data?.rentChargesReport?.pagination?.totalPages || 1
  const showPagination = currentDataCount > 0

  return (
    <>
      <div className="w-full px-4 md:px-6 space-y-6">
        <h2 className="text-xl md:text-2xl font-semibold">
          {texts.title}
        </h2>
        <div>
          <RentChargesFilters
            filters={filters}
            onFilterChange={handleFilterChange}
          />
        </div>
        <div>
          <RentChargesListTable
            filters={{
              ...filters,
              page: currentPage.toString(),
            }}
          />
        </div>
        {showPagination && (
          <div className="pt-2">
            <Pagination
              currentPage={currentPage}
              onPageChange={handlePageChange}
              currentDataCount={currentDataCount}
              pageSize={filters.pageSize || null}
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
    </>
  )
}
/* 
import { useState } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { RentChargesFilters, RentChargesListTable } from '../organism';
import { RentChargesReportFilterInput, OrderDirectionOption, PageSizeOption, useGetRentChargesReportQuery } from '@/graphql/generated';
import { Pagination } from '../molecules';
import { UpdateRentChargeFormModal } from '../templates';
import { UpdateRentChargeFormModalContextProvider } from '@/contexts';
import { useUserLanguage } from '@/customHooks';
import textsData from '@/textData/reportTexts.json';

const initialFilters: RentChargesReportFilterInput = {
  createdAtFrom: null,
  createdAtTo: null,
  typeOption: null,
  statusOption: null,
  orderDirection: OrderDirectionOption.Desc,
  pageSize: PageSizeOption.TwentyFive,
  page: null,
  search: null,
  countryId: null,
  stateId: null,
  cityId: null,
};

export const RentChargesReportPage = () => {
  const userLanguage = useUserLanguage()
  const texts = (userLanguage === 'es' ? textsData.es : textsData.en).rentChargeReport

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<RentChargesReportFilterInput>(initialFilters);

  const handleFilterChange = (newFilters: RentChargesReportFilterInput) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setFilters({ ...filters, page: page.toString() });
  };

  const { data } = useGetRentChargesReportQuery({
    variables: {
      filterInput: { ...filters, page: currentPage.toString() },
    },
    fetchPolicy: 'network-only',
  });

  const currentDataCount = data?.rentChargesReport?.items?.length || 0;
  const totalPages = data?.rentChargesReport?.pagination?.totalPages || 1;
  const showPagination = currentDataCount > 0;

  return (
    <UpdateRentChargeFormModalContextProvider>
      <Container fluid>
        <Row>
          <Col>
            <h2>{texts.title}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <RentChargesFilters filters={filters} onFilterChange={handleFilterChange} />
          </Col>
        </Row>
        <Row>
          <Col>
            <RentChargesListTable filters={{ ...filters, page: currentPage.toString() }} />
          </Col>
        </Row>
        {showPagination && (
          <Row>
            <Col>
              <Pagination
                currentPage={currentPage}
                onPageChange={handlePageChange}
                currentDataCount={currentDataCount}
                pageSize={filters.pageSize || null}
                totalPages={totalPages}
              />
            </Col>
          </Row>
        )}
      </Container>
      <UpdateRentChargeFormModal />
    </UpdateRentChargeFormModalContextProvider>
  )
}

 */